import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=45821442&"
import script from "./SuccessDialog.vue?vue&type=script&lang=ts&"
export * from "./SuccessDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports